import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { Review } from '@app/core/interfaces';
import { EventListenerService } from '@app/core/services/event-listener.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'ins-reviews',
    templateUrl: 'reviews.component.html',
    styleUrls: ['reviews.component.scss', '../review.shared.scss']
})
export class ReviewsComponent implements OnDestroy, AfterViewInit {
    @Input() reviews: Review[];
    @Input() itemsInView: number;
    @Input() showControls: boolean = true;

    @ViewChild('reviewCarousel', { static: true }) reviewCarousel: ElementRef;

    public itemWidth = 'auto';
    private resizeTimer$ = this.eventListenerService.windowEvent<Event>('resize').pipe(
        debounceTime(250)
    );
    private subscription: Subscription = new Subscription();
    constructor(
        private cd: ChangeDetectorRef,
        private eventListenerService: EventListenerService,
    ) {}

    public get test(): string {
        return typeof this.itemsInView;
    }
    ngAfterViewInit(): void {
        this.subscription.add(
            this.resizeTimer$.subscribe( () => this.calculateWidth() )
        );
        this.calculateWidth();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private calculateWidth(): void {
        if (!this.reviewCarousel) {
            return;
        }

        const clientWidth = this.reviewCarousel.nativeElement.clientWidth;
        const total = (this.itemsInView) ? this.itemsInView : 4;
        const width = Math.floor(clientWidth / total);

        this.itemWidth = `${width}px`;
        this.cd.detectChanges();
    }

    public get reviewsToDisplay(): Review[] {
        return this.itemsInView === 1 ? this.reviews?.slice(0, 4) : this.reviews;
    }

}
